import type { default as DB, MetainfoMVCC } from '../DB';

export function createDevDBMetainfoMVCC(
    dbFetch: (userId: string) => MetainfoMVCC,
    dbUpdateMetainfoMVCC: (id: string, cb: (payload: MetainfoMVCC) => void) => MetainfoMVCC,
): DB<any>['metainfoMVCC'] {
    return {
        addCancelledOnGameEndEventId: async (id, eventId) => {
            return dbUpdateMetainfoMVCC(id, (metainfoMVCC) => {
                metainfoMVCC.cancelledOnGameEndEventIds = (metainfoMVCC.cancelledOnGameEndEventIds ?? [])
                    .concat(eventId)
                    .slice(-5); // keep the latest 5 event IDs
            });
        },

        fetchMetainfoMVCC: async (id) => {
            return dbFetch(id);
        },

        updateScheduledActionNotifications: async (userId, updates) => {
            dbUpdateMetainfoMVCC(userId, (metainfoMVCC) => {
                const paths = ['systemScheduledActionNotifications', 'scheduledActionNotifications'] as const;

                for (const path of paths) {
                    if (!metainfoMVCC[path]) {
                        metainfoMVCC[path] = {};
                    }

                    for (const [notificationId, key] of Object.entries(updates[path])) {
                        if (key) {
                            metainfoMVCC[path]![notificationId] = key;
                        } else {
                            delete metainfoMVCC[path]![notificationId];
                        }
                    }
                }
            });
        },

        setPaymentSubscriptionStatus: async (id, status) => {
            return dbUpdateMetainfoMVCC(id, (metainfoMVCC) => {
                metainfoMVCC.paymentSubscription = status;
            });
        },
        unsetPaymentSubscriptionStatus: async (id: string) => {
            return dbUpdateMetainfoMVCC(id, (metainfoMVCC) => {
                delete metainfoMVCC.paymentSubscription;
            });
        },
        getPaymentSubscriptionStatus: async (id: string) => {
            const metainfoMVCC = dbFetch(id);

            return metainfoMVCC.paymentSubscription;
        },
    };
}
